<template>
  <div>
    <h1>Page Varibox</h1>
    <p>QR Code scanné : {{ scannedQrStore.qrCode }}</p>
  </div>
</template>

<script setup>
import { useScannedQrStore } from '@/stores/qrCode'

const scannedQrStore = useScannedQrStore()
</script>

<style scoped>
.varibox-page {
  padding: 20px;
  color: white;
}
</style>